<div class="card">
  <div class="card-body">
    <h2>
      Notifications
    </h2>
    <hr />
    <p>Notifications are handled through the notification.service. Click the buttons below and browse through the
      ipmlementations to figure out how to use them if/when needed.</p>
    <button type="button" class="btn btn-success" (click)="Success()">Success</button>
    <button type="button" class="btn btn-danger" (click)="Danger()">Danger</button>
    <button type="button" class="btn btn-warning" (click)="Warning()">Warning</button>
    <button type="button" class="btn btn-info" (click)="Info()">Info</button>
    <button type="button" class="btn btn-secondary" (click)="OverrideDefaults()">Override Defaults</button>
    <hr />
    <button type="button" class="btn btn-dark" (click)="Multiple()">Multiple Messages</button>
    <button type="button" class="btn btn-light" (click)="SplitMultiple()">Split Multiple Messages</button>
    <button type="button" class="btn btn-primary" (click)="MultipleWithOverrides()">Multiple with Overrides</button>
    <hr />
    <button type="button" class="btn btn-danger" (click)="RemoveAll()">Remove All Notifications</button>
    <button type="button" class="btn btn-danger" (click)="RemovePersistent()">Remove Persistent</button>
  </div>
</div>